import React from 'react';
import ChangePasswordForm from '@components/account_setting/form/ChangePasswordForm';

const ChangePasswordPageContent = () => {
  return (
    <>
      <div
        className={
          'text-neutral-whiteboard text-lg mb-4 font-semibold max-lg:hidden'
        }
      >
        Security
      </div>
      <ChangePasswordForm />
    </>
  );
};

export default ChangePasswordPageContent;
